import { c as r } from "./classof.js";
var o = String,
  t = function t(_t) {
    if ("Symbol" === r(_t)) throw TypeError("Cannot convert a Symbol value to a string");
    return o(_t);
  };
export { t };